// Klaviyo OAuth scopes required for the application
// These scopes are used across multiple OAuth flows and should be kept in sync
export const KLAVIYO_OAUTH_SCOPES = [
  "accounts:read",
  "templates:read",
  "templates:write",
  "campaigns:read",
  "campaigns:write",
  "flows:read",
  "flows:write",
  "lists:write",
  "profiles:write",
  "profiles:read",
  "metrics:read",
  "events:read",
  "events:write",
  "segments:read",
  "segments:write",
  "lists:read",
  // "subscriptions:write",
  // "subscriptions:read",
] as const;

// Type for the scopes array
export type KlaviyoOAuthScope = typeof KLAVIYO_OAUTH_SCOPES[number];
